export const normalizeBarcode = (value: string): string => {
    return value.trim()
}

export const normalizeBarcodeList = (barcodes: string[]): string[] => {
    const seen = new Set<string>()
    const result: string[] = []
    for (const raw of barcodes) {
        const value = normalizeBarcode(raw)
        if (!value || seen.has(value)) continue
        seen.add(value)
        result.push(value)
    }
    return result
}

export const barcodeQueryKey = (storageId: string, barcode: string) =>
    ['barcode', storageId, normalizeBarcode(barcode)] as const
